module.exports = __webpack_public_path__ + "img/add_bg_img.25ac032d.svg";